import { CircularProgress } from "@mui/material";
import { useMediaUrlWithState, useTranslation } from "hhn-commons";
import { CSSProperties, useEffect } from "react";
import MediaErrorPlaceholder from "./MediaErrorPlaceholder";

const DisplayVideo = ({
  url,
  containerStyle,
  onSetMediaUrl,
}: {
  url: string;
  containerStyle?: CSSProperties;
  onSetMediaUrl?: (url: string) => void;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const mediaState = useMediaUrlWithState(url);
  const signedUrl = mediaState.data?.signedUrl;

  useEffect(() => {
    if (signedUrl && onSetMediaUrl) {
      onSetMediaUrl(signedUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedUrl]);

  if (mediaState.error) {
    return (
      <MediaErrorPlaceholder
        variant="inline"
        kind="video"
        onRetry={mediaState.retry}
        data-testid="display-video-error"
      />
    );
  }

  if (!signedUrl) {
    return <CircularProgress />;
  }

  return (
    <video
      controls
      preload="none"
      src={signedUrl}
      width="80%"
      height="auto"
      data-testid="display-video"
      style={containerStyle}
    >
      {tNs("message.video.notSupported")}
    </video>
  );
};

export default DisplayVideo;
